// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { Text } from '@mysten/ui';

import { AddressLink } from '~/ui/InternalLink';
import { getKnownAccount } from '~/utils/knownAccounts';

// Small shield glyph marking a well-known/system account.
function SystemBadge() {
	return (
		<span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-hero-dark/10">
			<svg viewBox="0 0 24 24" className="h-2.5 w-2.5 text-hero-dark" fill="currentColor">
				<path d="M12 2l7 3v6c0 4.4-3 8.4-7 9.5C8 19.4 5 15.4 5 11V5l7-3z" />
			</svg>
		</span>
	);
}

// Renders a transaction sender: a tagged icon + friendly label (with the raw
// address beneath) for known/system accounts, or a plain address link otherwise.
export function SenderLabel({ address }: { address: string | null | undefined }) {
	if (!address) return <Text variant="bodySmall/medium">--</Text>;
	const known = getKnownAccount(address);
	if (!known) return <AddressLink address={address} />;
	return (
		<div className="flex flex-col gap-0.5">
			<div className="flex items-center gap-1.5">
				<SystemBadge />
				<Text variant="bodySmall/medium" color="steel-darker">
					{known.label}
				</Text>
			</div>
			<AddressLink address={address} />
		</div>
	);
}
